import { Stack } from '@mui/material'
import { WorkInstructionJobDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { EquipmentOperatorWorkInstructionStepperUIStore } from '../../stores/equipment-operator-work-instruction-stepper.ui-store'
import { WorkInstructionJobInformationWrapper } from '../JobInformation/WorkInstructionJobInformationWrapper'
import { ConfirmSignature } from './ConfirmSignature'
import { RadioButton } from './RadioButton'

interface Props {
  job: WorkInstructionJobDto
  stepperUiStore: EquipmentOperatorWorkInstructionStepperUIStore
}

export const FinishOrder = observer(({ job, stepperUiStore: uiStore }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <WorkInstructionJobInformationWrapper
      title={t(
        'doYouWantToMarkTheOrderAsCompleted?',
        'Do you want to mark the order as completed?',
      )}
      job={job}
      currentStep={uiStore.currentStepNumber}
      stepsTotal={uiStore.stepsTotal}
      showGeneralInformation={false}
    >
      <Stack gap={theme.customSpacing.m} marginY={theme.customSpacing.m}>
        <RadioButton
          selectedValue={uiStore.isJobMarkedAsComplete}
          value={true}
          title={t('yesMarkAsComplete', 'Yes, mark as complete')}
          subTitle={t(
            'plannedAmountWillBeUpdateToMatchWhatYouPicked',
            'Planned amount will be updated to match what you picked',
          )}
          onChange={() => uiStore.setJobMarkedAsComplete(true)}
        />
        <RadioButton
          selectedValue={uiStore.isJobMarkedAsComplete}
          value={false}
          title={t('noKeepOrderOpen', 'No, keep order open')}
          subTitle={t(
            'newJobWillBeCreatedWithMissingItems',
            'New job will be created with missing items',
          )}
          onChange={() => uiStore.setJobMarkedAsComplete(false)}
        />
      </Stack>

      {uiStore.needToDisplaySignature && uiStore.isJobMarkedAsComplete && (
        <ConfirmSignature stepperUiStore={uiStore} />
      )}
    </WorkInstructionJobInformationWrapper>
  )
})
